import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { MemberAccessFlow, MemberAccessFlowResponse } from 'src/modules/auth/models/auth';
import { AccessFlowForm } from './AccessFlowForm';
import { LoginFlow } from './LoginFlow';

export interface AccessFlowDetails {
    accessFlow: MemberAccessFlow;
    email: string;
    ssoUrl?: string;
}

export const LoginForm: React.FC = () => {
    const { t } = useTranslation();

    const [accessFlowDetails, setAccessFlowDetails] = useState<AccessFlowDetails>();

    const clearDetails = () => {
        setAccessFlowDetails(undefined);
    };

    const handleFetch = (accessFlowResponse: MemberAccessFlowResponse, email: string) => {
        const { accessFlow, ssoUrl } = accessFlowResponse;

        if (accessFlow === MemberAccessFlow.SSO && ssoUrl) {
            window.location.replace(ssoUrl);
        } else {
            setAccessFlowDetails({ email, ...accessFlowResponse });
        }
    };

    if (accessFlowDetails) {
        return <LoginFlow accessFlowDetails={accessFlowDetails} onGoBack={clearDetails} />;
    }

    return <AccessFlowForm onFetch={handleFetch} title={t('auth:login_form.title')} />;
};
